<div class="modal-header">
  <button
    type="button"
    (click)="onClickClose()"
    class="close"
    aria-label="Close"
  >
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title title">{{ titulo }}</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-xs-12 text-modal">
      <div
        *ngIf="!files.length"
        class="col-12 rmpm dropzone"
        appUploadArquivosDrop
        (change)="filesDropped($event)"
      >
        <div class="dropzone-content">
          <span class="icon foto-nuvem icon-nuvem"></span>
          <div class="text-wrapper">
            Arraste aqui
            <strong>todos os arquivos ou </strong>
            <a class="underline" (click)="fileInput.click()">clique aqui</a>
            para procurar
          </div>
        </div>
      </div>

      <span class="hidden">
        <input
          #fileInput
          type="file"
          multiple
          (change)="onFileSelected($event)"
          accept=".gif,.jpg,.jpeg,.png,.bmp,.pdf"
        />
      </span>

      <div class="col-xs-12">
        <div *ngIf="files.length > 0" class="space row">
          <div class="col-xs-4">
            {{ files.length }}
            {{
              files.length > 1
                ? ' arquivos selecionados'
                : ' arquivo selecionado'
            }}
          </div>
          <div class="col-xs-8 text-center">
            <p class="text-type">Tipo do documento</p>
          </div>
        </div>
      </div>
      <form class="forms">
        <div
          *ngFor="let file of files; index as i"
          class="droped-files col-xs-12"
        >
          <div *ngIf="file" class="droped-files-field row">
            <div class="droped-files-name col-xs-4">
              <img
                [src]="getThumbImage(file.file)"
                width="100px"
                height="100px"
                alt="Demostrativo de imagem"
              />
              <div>{{ file.file?.file?.name }}</div>
            </div>
            <div class="col-xs-7 text-right">
              <select
                class="form-control"
                [name]="'idDocumento' + i"
                [(ngModel)]="file.tipo"
                style="width: 100%"
                required
                (change)="onChangeTipo($event)"
              >
                <option value="undefined" selected hidden>Selecione...</option>
                <option
                  *ngFor="let documento of tiposDocumentos"
                  [value]="documento.idDocto"
                >
                  {{ documento.descDocto }}
                </option>
              </select>
            </div>
            <div class="col-xs-1">
              <a
                class="droped-files-remove"
                aria-label="Remover"
                (click)="removeFile(i)"
              >
                <i class="glyphicon glyphicon-trash"></i>
              </a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer space">
    <button
      type="button"
      class="btn btn-border-orange pull-left btn-size"
      (click)="onClickClose()"
    >
      {{ labelFechar }}
    </button>
    <div class="space">
      <button
        type="button"
        class="btn btn-border-orange pull-right btn-size"
        (click)="onClickAdicionar()"
        *ngIf="files.length > 0"
      >
        <i class="fa fa-plus btn-icon"></i>{{ labelAdicionar }}
      </button>
      <button
        type="button"
        class="btn btn-full-orange pull-right .btn-size-anexar"
        (click)="onClickAnexarDocumentos()"
        [disabled]="!validForm"
      >
        {{ labelOk }}
      </button>
    </div>
  </div>
  <app-loader-circles *ngIf="showLoader"></app-loader-circles>
</div>
